module.exports = __webpack_public_path__ + "img/hamochi.06a5d103.png";